import axios, {AxiosResponse} from "axios";
import {storageUtil} from "../helpers";

export const baseURL = process.env.REACT_APP_API_ROOT;
export const ResponseModel = AxiosResponse;
const authToken = storageUtil.getAuthToken();
const baseOptions = {
	baseURL: baseURL,
	timeout: 0,
	withCredentials: false,
	headers: {
		'Authorization': authToken
	}
};

export const api = axios.create(baseOptions);
export const asyncApi = axios.create(baseOptions);
